import './Header.scss'
import SimpleSlider from "../SliderPoster/SliderPoster";

export default function Header({continueWatchList}) {

    return (
        <header>
            <SimpleSlider continueWatchList={continueWatchList}/>
        </header>
    )
}
